<template>
    <div style="padding: 10px">
        <el-table
                border
                :data="tableList"
                :header-cell-style="headerCellStyle">
            <el-table-column
                    fixed
                    prop="date"
                    type="index"
                    label="序号"
                    align="center"
                    width="60px">
                <template scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    fixed
                    prop="handleFileNumber"
                    align="center"
                    label="处理文件文号"
                    :show-overflow-tooltip="true"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="handleDepartment"
                    align="center"
                    label="实施/认定部门"
                    :show-overflow-tooltip="true"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="violationType"
                    label="违规类型"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="205px">
            </el-table-column>
            <el-table-column
                    prop="punishDate"
                    align="center"
                    label="违规时间"
                    width="100">
                <template scope="scope">
                    <p>{{scope.row.punishDate?formatDate(scope.row.punishDate,"yyyy-MM-dd"):'--'}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="punishContent"
                    label="处罚事由(违法违规事项名称)"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="200px">
            </el-table-column>
            <el-table-column
                    prop="dataSource"
                    align="center"
                    label="数据来源"
                    :show-overflow-tooltip="true"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="登记时间"
                    align="center"
                    width="100">
                <template scope="scope">
                    <p>{{scope.row.createTime?formatDate(scope.row.createTime,"yyyy-MM-dd"):'--'}}</p>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total">
        </el-pagination> -->
    </div>
</template>
<script>
    export default {
        data(){
            return {
                headerCellStyle:{
                    'background-color': '#EFF3F6',
                    'font-size': '14px',
                    'color': '#000000',
                },
                tableList:[],
                total:0,
                currentPage:1,
                pageSize:10,
            }
        },
        created() {
            // this.queryData();
        },
        methods: {
            // 获取数据
            // queryData(){
            //     let url = '/entPunish/list';
            //     this.$httpReq.post(url,{
            //         page:this.currentPage,
            //         rows:this.pageSize,
            //         filter:{
            //             entId:this.$route.params.id || this.orgId,
            //             dataType:1 // dataType：1-违法违规 2行政处罚 3-不良行为 4-黑名单记录 5-失信联合惩戒
            //         },
            //         searchKey: '',
            //         orderBy:'create_time desc'
            //     }).then((res)=>{
            //         if(res.data){
            //             this.tableList = res.data.rows;
            //             this.total = res.data.total;
            //         }
            //     })
            // },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                // this.queryData();
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>